import React from 'react';

const RequiredCheck = () => {
  return<span className={'text-danger'}>*</span>
}

export default RequiredCheck;
